/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const ForwardBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="m5.5 8.603 5.417 3.883L5.5 16.393v-7.79Zm5.5 2.13L6.163 7.242l-.001-.001C5.232 6.618 4 7.292 4 8.398v8.2c0 1.106 1.233 1.78 2.162 1.158l.002-.002L11 14.24v2.359c0 1.106 1.233 1.78 2.162 1.158l.002-.002 6.302-4.096a1.394 1.394 0 0 0 0-2.315l-6.303-4.115-.001-.001C12.232 6.604 11 7.278 11 8.384v2.35Zm1.5-2.144 6 3.91-6 3.894V8.589Z" /></svg>);
const Forward = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={ForwardBase} {...rest} ref={ref} />);
export default Forward;